import axios from 'axios/index';
import { CREATE_AGENT } from '../../utils/constants';

const addAgent = (data, hash) => {
    return axios.post(CREATE_AGENT,
        data, {
        headers: {
            "Accept": "application/json",
            "Accept-language": "bg",
            "Authorization": hash
        }
    }).then(resp => {
        return resp;
    }).catch(err => {
        console.error(err)
    })
}

export default addAgent;